import {planTypes} from "@/common/constants";

export default {
  data () {
    return {
      logo: require('@/assets/plans/zoom_video_management.svg'),
      title: this.$t('billing.video_management.title'),
      planType: planTypes.VIDEO_MANAGEMENT,
      trackingPlanName: 'zoom video management',
    }
  }
};
